module.exports = __webpack_public_path__ + "static/media/image_keyword_04.c2d554c0.webp";